import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssessmentCentralService } from "../../../../shared/services/assessment-central.service";

@Component({
  selector: "assessment-template-create-modal",
  templateUrl: "assessment-template-create-modal.html",
  styleUrls: ["assessment-template-create-modal.scss"],
})
export class AssessmentCreateTemplateModalDialogComponent {
  categories: any;
  assessmentTags: any;
  isTemplateFileRequired: boolean = true;
  responseOptions: any = [];
  selectedResponses: string[] = [];

  templateForm = new FormGroup({
    name: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    applicability: new FormControl(""),
    assessment_scoring_scale: new FormControl(""),
    category: new FormControl("", [Validators.required]),
    responses: new FormControl([], [Validators.required]),
  });

  constructor(
    public dialogRef: MatDialogRef<AssessmentCreateTemplateModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly assessmentCentralService: AssessmentCentralService
  ) {}

  ngOnInit() {
    this.isTemplateFileRequired = this.data?.isFileRequired !== false;

    this.getCategories();
    const responsesControl = this.templateForm.get("responses");
    if (!this.isTemplateFileRequired) {
      responsesControl?.setValidators([Validators.required]);
      this.getResponseOptions();
    } else {
      responsesControl?.clearValidators();
    }
  }

  getResponseOptions() {
    this.assessmentCentralService
      .getAssessmentResponseChoices()
      .subscribe((resp: any) => {
        this.responseOptions = resp;
      });
  }

  getCategories() {
    this.assessmentCentralService
      .getAssessmentTemplateCategory()
      .subscribe((response) => {
        this.categories = response;
      });
  }

  getChildTags(data: any) {
    this.assessmentTags = data;
  }

  addResponse(value: string): void {
    if (value && !this.selectedResponses.includes(value)) {
      this.selectedResponses.push(value);
      this.templateForm.get("responses")?.setValue(this.selectedResponses);
    }
  }

  removeResponse(index: number): void {
    this.selectedResponses.splice(index, 1);
    this.templateForm.get("responses")?.setValue(this.selectedResponses);
  }

  createAssessment() {
    const dialogData = this.templateForm.value;
    dialogData["selectedTags"] = this.assessmentTags;
    this.dialogRef.close(dialogData);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
